import React from 'react';
import PropTypes from 'prop-types';
import { MICRO_TEXT_MAX_CHARACTERS } from 'constants/logic';
import Input from '../Input/Input';

import './SocialMediaInput.scss';

const SocialMediaInput = ({ staticText, ...props }) => {
  return (
    <Input
      {...props}
      className="social-media-input"
      inputClassName="social-media-input__input"
      maxLength={MICRO_TEXT_MAX_CHARACTERS}>
      <span className="social-media-input__static">{staticText}</span>
    </Input>
  );
};

SocialMediaInput.propTypes = {
  staticText: PropTypes.string,
};

export default SocialMediaInput;
